import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../LifeAgents.module.scss';
import metadata from './RiskInformationComponent.metadata.json5';
import RiskTableComponent from '../subcomponents/RiskTable/RiskTableComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function RiskInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('RiskInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        riskTableComponent: {
            data: modelVM.riskTable,
            updateWizardData,
            submissionVM,
            RiskTablePath: `${pathUpdated}.riskTable`
        },
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        '@dropdownSelect': {
            showRequired: true,
        },
        des10: {
            visible: !_.isUndefined(modelVM.doeTheAppSOrAnyOf9.value) && modelVM.doeTheAppSOrAnyOf9.value === false
        },
        des12: {
            visible: !_.isUndefined(modelVM.hasAppSOrAnyOfApp11.value) && modelVM.hasAppSOrAnyOfApp11.value === true
        },
        des14: {
            visible: !_.isUndefined(modelVM.isTheAppAMemInGoo13.value) && modelVM.isTheAppAMemInGoo13.value === false
        },
        des16: {
            visible: !_.isUndefined(modelVM.doeTheAppSAntAMer15.value) && modelVM.doeTheAppSAntAMer15.value === true
        },
        des18: {
            visible: !_.isUndefined(modelVM.doeTheAppCurHolALic17.value) && modelVM.doeTheAppCurHolALic17.value === true
        },
        des37: {
            visible: !_.isUndefined(modelVM.doeTheAppSProForFin36.value) && modelVM.doeTheAppSProForFin36.value === true
        },
        ifYesAreProProSolBy39: {
            visible: !_.isUndefined(modelVM.isTheAppSLicToSel38.value) && modelVM.isTheAppSLicToSel38.value === true
        },
        areAllProOfTheInvLif41: {
            visible: !_.isUndefined(modelVM.doeTheAppSEngInThe40.value) && modelVM.doeTheAppSEngInThe40.value === true
        },
        appLicProvLis: {
            availableValues: ["Alb", "BriCol", "Man", "NewBru", "NewAndLab", "NorTer", "NovSco", "Nunavut", "Ont", "PriEdwIsl", "Quebec", "Sas", "Yukon"]
                .map((province) => ({
                    code: province,
                    name: {
                        id: `typekey.PPLPPLSelJur.${province}`,
                        defaultMessage: province
                    }
                }))
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            riskTableComponent: RiskTableComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

RiskInformationComponent.propTypes = wizardProps;
export default withRouter(RiskInformationComponent);
